import { create } from "zustand";

export const useActasStore = create((set) => ({
  actas: [],
  actasFilter: [],
  estadoBuscado: null,

  filtersFields: null,

  actaDetalle: null,
  actasDetalle: [],

  actasBuscadas: [],

  codigosZonales: ["8300", "8309", "8324", "8316"],
  codigosForaneos: null,

  localidades: null,
  cp: null,
  tipos: null,

  actaAImprimir: null,

  filtros: {
    tipo: "",
    localidad: "",
    fecha_desde: "",
    fecha_hasta: "",
  },

  setEstadoBuscado: (estado) => {
    set({ estadoBuscado: estado });
  },

  firstSetActas: (actas) => {
    set({
      actas: actas,
      actasFilter: actas,
    });
  },

  cleanActas: () => {
    set({
      actas: [],
      actasFilter: [],
    });
  },

  setActas: (actas) => {
    set({
      actas: actas,
    });
  },
  setActasFilter: (actas) => {
    set({
      actasFilter: actas,
    });
  },

  setActaDetalle: (acta) => {
    set({ actaDetalle: acta });
  },

  setActasDetalle: (acta) => {
    if (acta.length == 0) {
      set((state) => ({
        actasDetalle: [],
      }));
    } else {
      set((state) => ({
        actasDetalle: [...state.actasDetalle, acta],
      }));
    }
  },
  setReplaceActasDetalle: (actas) => {
    set({ actasDetalle: actas });
  },

  setActasBuscadas: (acta) => {
    if (acta.length == 0) {
      set((state) => ({
        actasBuscadas: [],
      }));
    } else {
      set((state) => ({
        actasBuscadas: [...state.actasBuscadas, acta],
      }));
    }
  },

  setActaAImprimir: (value) => {
    set({ actaAImprimir: value });
  },

  setLocalidades: (localidades) => {
    set({ localidades: localidades });
  },

  setCodigosForaneos: (codigos) => {
    set({ codigosForaneos: codigos });
  },

  setCp: (cp) => {
    set({ cp: cp });
  },

  setTipos: (tipos) => {
    set({ tipos: tipos });
  },

  setActa: (acta) => {
    set((state) => ({
      actaDetalle: { ...state.actaDetalle, acta: acta },
    }));
  },
  setArchivos: (archivos) => {
    set((state) => ({
      actaDetalle: { ...state.actaDetalle, archivos: archivos },
    }));
  },

  setFilterField: (field, value) => {
    set((state) => ({
      filtersFields: { ...state.filtersFields, [field]: value },
    }));
  },

  removeFilterField: (field) => {
    set((state) => {
      const { [field]: _, ...remainingFields } = state.filtersFields;
      return {
        filtersFields: remainingFields,
      };
    });
  },
}));
